import { WaitingScope } from 'src/components/waiting/waiting.scopes'
import { Observable, observe, Scope } from 'wdc-cube'
import { StatusProcessamentoBordero } from '../bordero.types'

@Observable
export class StatusProcessamentoScope extends Scope {
    @observe() waiting?: WaitingScope
    @observe() resultados = [] as StatusProcessamentoBordero[]

    onClose = Scope.ASYNC_ACTION
    onFind = Scope.ASYNC_ACTION_STRING
}

export default StatusProcessamentoScope
